import { makeStyles } from 'tss-react/mui';

const useStylesFlexContainer: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  flexContainerSpread: {
    width: '100%',
    justifyContent: 'space-between',
  },
  flexContainerStart: {
    justifyContent: 'flex-start',
  },
  flexContainerEnd: {
    justifyContent: 'flex-end',
  },
  flexContainerColumn: {
    flexDirection: 'column',
  },
  flexContainerFlexStart: {
    alignItems: 'flex-start',
  },
  flexContainerSpaceAround: {
    justifyContent: 'space-around',
  },
  flexContainerNoAlign: {
    alignItems: 'normal',
  },
  flexContainerInline: {
    display: 'inline-flex',
  },
  flexContainerCentered: {
    justifyContent: 'center',
  },
  flexContainerFloatRight: {
    float: 'right',
  },
  flexContainerFloatLeft: {
    float: 'left',
  },
  flexContainerFullHeight: {
    height: '100%',
  },
  flexContainerFullWidth: {
    width: '100%',
  },
  flexContainerTextLeft: {
    textAlign: 'left',
  },
  flexContainerTextCenter: {
    textAlign: 'center',
  },
  flexContainerDefault: {
    alignItems: 'normal',
  },
}));

export default useStylesFlexContainer;
